import type { SetURLSearchParams } from 'react-router'

export type Bucket =
	| 'draft'
	| 'collecting'
	| 'ready'
	| 'purchased'
	| 'paused'
	| 'cancelled'

export const BUCKET_CHIPS: Array<{ key: Bucket | undefined }> = [
	{ key: undefined },
	{ key: 'draft' },
	{ key: 'collecting' },
	{ key: 'ready' },
	{ key: 'purchased' },
	{ key: 'paused' },
	{ key: 'cancelled' },
]

const BUCKETS = new Set<Bucket>(
	BUCKET_CHIPS.flatMap((chip) => (chip.key ? [chip.key] : [])),
)

export function parseBucket(value: string | null): Bucket | undefined {
	return value && BUCKETS.has(value as Bucket) ? (value as Bucket) : undefined
}

export type AdminLotFilters = {
	bucket?: Bucket
	createdBy?: string
	search?: string
}

export function parseAdminLotFilters(params: URLSearchParams): AdminLotFilters {
	return {
		bucket: parseBucket(params.get('f')),
		createdBy: params.get('c') ?? undefined,
		search: params.get('q') ?? undefined,
	}
}

export function replaceAdminLotFilters(
	setParams: SetURLSearchParams,
	filters: Partial<AdminLotFilters>,
) {
	setParams(
		(prev) => {
			const next = new URLSearchParams(prev)
			if ('bucket' in filters) {
				if (filters.bucket) next.set('f', filters.bucket)
				else next.delete('f')
			}
			if ('createdBy' in filters) {
				if (filters.createdBy) next.set('c', filters.createdBy)
				else next.delete('c')
			}
			if ('search' in filters) {
				if (filters.search !== undefined) {
					const trimmed = filters.search.trim()
					if (trimmed) next.set('q', filters.search)
					else next.delete('q')
				}
			}
			return next
		},
		{ replace: true },
	)
}

export function replaceBucketParam(
	setParams: SetURLSearchParams,
	bucket: Bucket | undefined,
) {
	replaceAdminLotFilters(setParams, { bucket })
}

export function hasAdminLotFilters(filters: AdminLotFilters): boolean {
	return Boolean(filters.bucket || filters.createdBy || filters.search?.trim())
}
